import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { ApiUrl } from '../api_url'
import axios from 'axios'

import { nullToString } from 'utils/nullToString';

const initialState = {
  video: null,
  items:[],
  status: "idle",
  error:null,
  editing: { status:'idle', error: null},
  creating: { status:'idle', error: null},
  deleting: { status: 'idle', error: null},
  downloading: { status: 'idle', error: null},

}

export const fetchVideos = createAsyncThunk('videos/fetchVideos', async () => {

  const response = await axios.get(ApiUrl + "videos");
  return response.data

})

export const videoAdded = createAsyncThunk('videos/videoAdded', async (payload, thunkAPI) => {

  console.log(payload);
  const response = await axios.post(ApiUrl + "videos", payload);
  return response.data

})

export const videoUpdated = createAsyncThunk('videos/videoUpdated', async (payload, thunkAPI) => {

  console.log(payload);
  const response = await axios.put(ApiUrl + "videos/" + payload.id, payload.video);
  return response.data

})

export const videoDeleted = createAsyncThunk('videos/videoDeleted', async (payload, thunkAPI) => {

  console.log('videos/videoDeleted: ', payload);
  const response = await axios.delete(ApiUrl + "videos/" + payload.videoId);
  return response.data

})

export const videoDownloaded = createAsyncThunk('videos/downloadVideo', async (payload, thunkAPI) => {

  const response = await axios.get(ApiUrl + "videos/download/" + payload.id, 
    {
      responseType: 'arraybuffer',
      headers: {
        'Content-Type': 'video/mp4'
      }
    }
  );

  return response.data

})

export const videosSlice = createSlice({
  name: 'videos',
  initialState,
  reducers: {

    reset: state => initialState

  },
  extraReducers(builder) {
    builder
  
      // FETCH videos
      .addCase(fetchVideos.pending, (state, action) => {
        state.status = 'loading';
      })
      .addCase(fetchVideos.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.error = null;
        // Add any fetched Videos to the array
        state.items = [];
        state.items = state.items.concat(action.payload.map(item => nullToString(item)));

      })
      .addCase(fetchVideos.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      // CREATE Video
      .addCase(videoAdded.pending, (state, action) => {
        state.creating.status = 'inprogress';
      })
      .addCase(videoAdded.fulfilled, (state, action) => {
        state.creating.status = 'succeeded';
        state.creating.error = null;
        // Add any fetched Videos to the array
        state.items.push(action.payload.video);
      })
      .addCase(videoAdded.rejected, (state, action) => {
        state.creating.status = 'failed';
        state.creating.error = action.error.message;
      })
      // UPDATE Video
      .addCase(videoUpdated.pending, (state, action) => {
        state.editing.status = 'pending';
      })
      .addCase(videoUpdated.fulfilled, (state, action) => {
        const index = state.items.findIndex(function(o){
          return o.id == action.payload.id;
        })

        state.items[index] = action.payload;
        state.editing.status = 'success';

        // state.items.push(action.payload)
      })
      .addCase(videoUpdated.rejected, (state, action) => {
        state.editing.status = 'failed';
        state.editing.error = action.error.message;
      })

      // DELETE video
      .addCase(videoDeleted.pending, (state, action) => {
        state.deleting.status = 'pending';
      })
      .addCase(videoDeleted.fulfilled, (state, action) => {
        console.log('video delete fullfiled', action);
        const index = state.items.findIndex(function(o){
          return o.id == action.payload;
        })

        state.items.splice(index,1);
        state.deleting.status = 'success';
        
      })
      .addCase(videoDeleted.rejected, (state, action) => {
        state.deleting.status = 'failed';
        state.deleting.error = action.error.message;
      })

      // DOWNLOAD VIDEO PRODUCT
      .addCase(videoDownloaded.pending, (state, action) => {
        state.downloading.status = 'pending';
      })
      .addCase(videoDownloaded.fulfilled, (state, action) => {
        console.log("Download ", action);
        state.downloading.status = 'success';
        
      })
      .addCase(videoDownloaded.rejected, (state, action) => {
        state.downloading.status = 'failed';
        state.downloading.error = action.error.message;
      })
  }

})

// Action creators are generated for each case reducer function
export const { reset } = videosSlice.actions;

export const selectAllVideos = state => state.videos.items;
export const selectVideosCount = state => state.videos.items.length;

export const selectVideoById = (state, videoId) => {

  let foundItem = null;
  if(state.videos.items.length > 0) {
    console.log("video PRESENT");
    foundItem = state.videos.items.find(video => video.id == videoId);

    foundItem = foundItem ? nullToString(foundItem) : undefined;
    
  }
  return foundItem;
}

export default videosSlice.reducer;